<template>
  <v-container :key="engineData" fluid grid-list-md fill-height style="padding:0px 10px 5px 10px; width:100%;">
    <v-layout row>
      <v-flex d-flex md5>
        <v-layout column fill-height>
          <v-flex d-flex md3 style="max-height:30%;">
            <v-card style="height:100%;width:100%;">
              <v-layout column fill-height>
                <v-flex v-for="tag in ['kpi','sfoc']" :key="tag" d-flex md6>
                  <v-layout row v-if="gaugeData[tag]">
                    <v-flex class="title" style="align-items:center;padding:15px;" d-flex md3>{{ gaugeData[tag].title }}</v-flex>
                    <v-flex d-flex md9>
                      <hor-gauge :value="gaugeData[tag].value" :maxValue="gaugeData[tag].maxValue" :minValue="gaugeData[tag].minValue" :color="gaugeData[tag].color"/>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex md5>
            <v-card style="height:100%;width:100%;">
              <v-card-title primary class="title" style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">Subsystems KPI</v-card-title>
              <v-card-actions fill-height style="height:85%;width:100%;padding-top:0px;padding-bottom:0px;">
                <v-layout row style="height:100%;width:100%;">
                  <v-flex v-for="sys in subSystems" :key="sys" d-flex :style="'max-width:'+(100/subSystems.length)+'%;'">
                    <v-layout column fill-height>
                      <v-flex d-flex md9 style="max-height:75%;">
                        <CircGauge v-if="gaugeData[sys.tag]" v-bind:value="gaugeData[sys.tag].value" v-bind:labelText="gaugeData[sys.tag].labelText" v-bind:color="gaugeData[sys.tag].color" v-bind:fontSize="22"/>
                      </v-flex>
                      <v-flex d-flex md3 style="font-size:18px;font-weight:400;align-items:center;justify-content:center;max-height:25%;">{{ sys.name }}</v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex d-flex md5>
            <Chart v-if="chartData['issues']" v-bind:chartOptions="chartData['issues']" v-bind:title="'Issues / Subsystem'" v-bind:active="active"/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex md7>
        <v-layout column fill-height>
          <v-flex d-flex md2 style="max-height: calc(100% / 12 * 2)">
            <v-card style="height:100%;width:100%;">
              <v-card-title primary class="title" style="height:30%;width:100%;padding-top:5px;padding-bottom:5px;">Specifications</v-card-title>
              <v-card-actions fill-height style="height:70%;width:100%;padding-top:0px;padding-bottom:0px;">
                <dx-data-grid class="grid" :data-source="specifData" :show-column-lines="true" :show-row-lines="true" :show-borders="true" :word-wrap-enabled="true" :row-alternation-enabled="false" :column-auto-width="true">
                  <DxPaging :page-size="2"/>
                  <dx-column data-field="controlSystem" caption="Control System"/>
                  <dx-column data-field="bore" caption="Bore (mm)"/>
                  <dx-column data-field="engSpeed" caption="Engine Speed (rpm)"/>
                  <dx-column data-field="powerSpeed" caption="Power (kW)"/>
                  <dx-column data-field="cylinderNo" caption="Cylinders"/>
                </dx-data-grid>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex d-flex md5 style="max-height: calc(100% / 12 * 5)">
            <v-card style="height:100%;width:100%;">
              <v-card-title primary class="title" style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">Engines Details</v-card-title>
              <v-card-actions fill-height style="height:85%;width:100%;padding-top:0px;padding-bottom:0px;">
                <dx-data-grid
                    class="grid"
                    :data-source="gridData"
                    :show-column-lines="true"
                    :show-row-lines="true"
                    :show-borders="true"
                    :word-wrap-enabled="true"
                    :row-alternation-enabled="false"
                    :column-auto-width="true"
                    @cellClick="gridClick"
                    @cellPrepared="cellPrepared">
                  <dx-column data-field="shComp" caption="Shipping Company"/>
                  <dx-column data-field="vessName" caption="Vessel"/>
                  <dx-column data-field="avgKPI" caption="Avg Engine KPI" format="percent"/>
                  <dx-column data-field="minKPI" caption="Minimum Engine KPI" format="percent"/>
                  <dx-column data-field="comp" caption="Components with Issues"/>
                  <dx-column data-field="freqIss" caption="Most Frequent Issue"/>
                  <dx-column data-field="lastIss" caption="Last Issue"/>
                </dx-data-grid>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex d-flex md5 style="max-height: calc(100% / 12 * 5)">
            <v-card style="height:100%;width:100%;">
              <v-card-title primary class="title" style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">{{ selEngine }} Issues</v-card-title>
              <v-card-actions fill-height style="height:85%;width:100%;padding-top:0px;padding-bottom:0px;">
                <v-layout row style="height:100%;width:100%;">
                  <v-flex d-flex md8>
                    <dx-data-grid
                        class="grid"
                        :data-source="issueData"
                        :show-column-lines="true"
                        :show-row-lines="true"
                        :show-borders="true"
                        :word-wrap-enabled="true"
                        :row-alternation-enabled="false"
                        :column-auto-width="true">
                      <dx-column data-field="desc" caption="Issue Description"/>
                      <dx-column data-field="subSys" caption="Subsystem"/>
                      <dx-column data-field="issueCount" caption="Issue Counter"/>
                      <dx-column data-field="engCount" caption="Engine Counter" cell-template="btnCell"/>
                      <div slot="btnCell" slot-scope="{ data: cellData }">{{ cellData.value }}</div>
                    </dx-data-grid>
                  </v-flex>
                  <v-flex d-flex md4>
                    <Chart v-if="chartData['topIssues']" v-bind:chartOptions="chartData['topIssues']" v-bind:title="'Top issues'" v-bind:active="active" v-bind:flat="true"/>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Chart from '../components/Chart'
import HorGauge from '../components/HorGauge'
import CircGauge from '../components/CircGauge'
import {DxDataGrid, DxColumn, DxPaging, DxScrolling} from 'devextreme-vue/data-grid';

export default {
  name: "EngineView",
  components: {
    HorGauge,
    Chart,
    DxDataGrid,
    DxColumn,
    DxPaging,
    // DxScrolling,
    CircGauge
  },
  data() {
    return {
      subSystems: [
        {
          name: 'Servo Oil',
          tag: 'so'
        },
        {
          name: 'Fuel Injection',
          tag: 'fi'
        },
        {
          name: 'Scavenge Air',
          tag: 'sac'
        },
        {
          name: 'Exhaust Gas',
          tag: 'egs'
        },
        {
          name: 'Piston Running',
          tag: 'pr'
        },
      ],
      chartData: {},
      gaugeData: {},
      gridData: [],
      issueData: [],
      specifData: []
    }
  },
  props: {
    active: Boolean,
    selEngine: String,
    engineData: Object
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    gridClick(e) {
      if ((e.column.dataField == "vessName") && (e.rowType != "header")) {
        this.$emit('vesselSelected', e.value);
      }
    },
    cellPrepared(e) {
      if ((e.column.dataField == "vessName") && (e.rowType != "header")) {
        e.cellElement.classList.add('clickable');
      }
    },
    setData() {
      if (this.engineData.fuelType =='Dual Fuel') {
        if (this.subSystems.filter((i) => {
          return i.name == 'Gas Admission';
        }).length < 1) {
          this.subSystems.push({
            name: 'Gas Admission',
            tag: 'gas'
          })
        }
      } else {
        this.subSystems = this.subSystems.filter((i) => {
          return i.name != 'Gas Admission';
        })
      }

      this.specifData = [];

      this.specifData.push({
        "controlSystem": this.engineData.controlSystem,
        "bore": this.engineData.bore,
        "engSpeed": this.engineData.engSpeed,
        "powerSpeed": this.engineData.powerSpeed,
        "cylinderNo": this.engineData.cylinderNo
      });

      this.$set(this.chartData, 'issues', {
        chart: {
          height: 0,
          zoomType: 'xy'
        },
        legend: {
          enabled: false
        },
        xAxis: {
          categories: this.subSystems.map(function (item) {
            return item.name;
          }),
          crosshair: true
        },
        yAxis: {
          title: {
            text: undefined
          }
        },
        exporting: {
          enabled: false
        },
        title: {
          text: undefined
        },
        series: [{
          type: 'column',
          animation: false,
          data: [],
          states: {
            hover: {
              enabled: false
            },
            normal: {
              animation: false
            },
            inactive: {
              opacity: 1
            }
          }
        }],
        tooltip: {
          formatter: function () {
            return this.point.name + ': ' + this.point.y.toFixed(1);
          }
        },
        credits: {enabled: false}
      });

      for (let i = 0; i < this.subSystems.length; i++) {
        let tag = this.subSystems[i].tag,
            fault_tag = tag + 'FaultNo',
            val = this.engineData[tag + '_KPI'] * 100,
            lText = ((val > 0) ? val.toFixed(0) + " %" : '-');

        this.chartData['issues'].series[0].data.push({
          y: this.engineData[fault_tag],
          name: this.subSystems[i].name,
          color: 'rgb(144,170,218)'
        });

        this.$set(this.gaugeData, tag, {
          value: val.toFixed(0),
          color: this.engineData[tag + '_KPI_color'],
          labelText: lText
        });
      }

      this.gaugeData['kpi'] = {
        'title': 'Engine KPI',
        'value': (this.engineData.eng_KPI * 100).toFixed(0),
        'maxValue': 100,
        'minValue': 0,
        'color': ((this.engineData.eng_KPI_color == 0) ? 'rgb(60, 171, 48)' : ((this.engineData.eng_KPI_color == 10) ? 'rgb(255, 184, 29)' : 'rgb(205, 57, 64)')),
      };

      this.gaugeData['sfoc'] = {
        'title': 'SFOC',
        'value': this.engineData.bsfc > 0 ? this.engineData.bsfc.toFixed(2) : '-',
        'maxValue': 220,
        'minValue': 150,
        'color': 'rgb(144,170,218)',
      };

      this.gridData = [];

      for (let i = 0; i < this.engineData.engines.length; i++) {
        let eng = this.engineData.engines[i];

        let compString = '';

        if (eng.compWithFaults.length > 0)
          compString = eng.compWithFaults.reduce(function (total, newString) {
            return total + " / " + newString;
          });

        this.gridData.push({
          shComp: eng.shippingCompany,
          vessName: eng.vessel,
          avgKPI: eng.avgEngKPI,
          minKPI: eng.minEngKPI,
          comp: compString,
          freqIss: eng.topFault,
          lastIss: eng.lastFault
        });
      }

      this.issueData = [];

      for (let i = 0; i < this.engineData.faults.length; i++) {
        let fault = this.engineData.faults[i];

        this.issueData.push({
          desc: fault.description,
          subSys: fault.subSystem,
          issueCount: fault.faultCounter,
          engCount: fault.engCounter

        });
      }

      this.$set(this.chartData, 'topIssues', {
        chart: {
          height: 0,
        },
        exporting: {
          enabled: false
        },
        title: {
          text: undefined
        },
        plotOptions: {
          pie: {
            shadow: false,
            center: ['50%', '50%'],
            dataLabels: {
              enabled: false
            },
          }
        },
        series: [{
          type: 'pie',
          animation: false,
          data: [],
          size: '100%',
          innerSize: '70%',
          states: {
            hover: {
              enabled: false
            },
            normal: {
              animation: false
            },
            inactive: {
              opacity: 1
            }
          }
        }],
        tooltip: {
          formatter: function () {
            return this.point.name + ': ' + this.point.y.toFixed(1);
          }
        },
        credits: {enabled: false}
      });

      for (let j = 0; j < this.engineData.topFaults.length; j++) {
        this.chartData.topIssues.series[0].data.push({
          y: Number(this.engineData.topFaults[j].percentage),
          name: this.engineData.topFaults[j].description
        });
      }
    }
  },
  watch: {
    selEngine: function () {
      this.setData();
    },
    engineData: function () {
      this.setData();
    }
  }
}
</script>

<style scoped>

</style>
